import React from 'react';

export const TabNav = ({ title, onHover, isActive, processStyles }) => {
  const Icon = processStyles.icon;

  return (
    <div className="processes-tab">
      <Icon className={`dot ${isActive ? 'is-active' : ''}`} alt={title} />
      <button
        type="button"
        onMouseOver={onHover}
        onFocus={onHover}
        title={title}
        className={`btn ${processStyles.tabClass} processes-tab-button`}
      >
        {title}
      </button>
    </div>
  );
};
